module.exports = __webpack_public_path__ + "static/media/boto.360ff008.webp";